import { post } from '@/utils/request'

export default {
    getVCList: query => post('/rrbi/videocollection/getVCList', query),
}
